import {
  idManager,
  dataService,
  getIndexedId
} from "@thegetty-private/rad-app-utils";
import internal from "@/data/internal-ontologies";

export async function getLinksFromIdManager(queries) {
  let items = [];
  // related content (videos & exhibitions)

  for (let query of queries) {
    const idManagerResponse = await idManager.queryIdManager(query);
    items = items.concat(idManagerResponse?.data?.items || []);
  }

  // FIXME - is this temp fix for null still needed?
  // @todo temporary fix for null appearing id manager response target
  items = items.filter((result) => !result.target.id.includes("null"));

  let typeMap = {};

  // for each of the items, put them into the appropriate bucket and get the title / format
  items.forEach((item) => {
    if (typeMap[item.target.generator] == undefined) {
      typeMap[item.target.generator] = [];
    }
    typeMap[item.target.generator].push({
      id: item.target.id,
      title: item["dcterms:title"],
      format: item.target.format
    });
  });

  return typeMap;
}

/**
 * gets the elasticsearch data and sets up the object profile and structure
 *
 * @param {string} indexedId - the indexedId
 * @param {string} apiPath - the API Path
 * @async
 *
 */
export async function getElasticData(indexedId, apiPath) {
  let result = {};
  try {
    result = await dataService.getElasticObject(indexedId, apiPath);
  } catch (e) {
    console.error(e);
  }
  return result;
}

/**
 * Gets the recommended artworks links
 *
 * @param {object} searchParams - the search parameters
 * @param {string} apiPath - the API Path
 *
 * @returns {array}
 */
export async function getRecommendedArtwork(searchParams, apiPath) {
  const similarUrl = apiPath + "api/similar-objects";
  let results = undefined;
  try {
    results = await dataService.axiosGet(similarUrl, undefined, searchParams);
  } catch (e) {
    console.error(e);
  }

  if (
    results &&
    typeof results.data == "string" &&
    results.data.includes("error")
  ) {
    return;
  }

  return results?.data;
}
/**
 * Gets the List of Galleries
 *
 * @param {string} apiPath - the API Path
 *
 * @returns {object}
 */
export async function getGalleryList(path = apiPath) {
  const url = path + "api/galleries";
  try {
    const response = await dataService.axiosGet(url);
    return response.data;
  } catch (e) {
    console.error(e);
  }
  return {};
}

/**
 * Gets the Exhibition List
 *
 * @param {string} apiPath - the API Path
 *
 * @returns {array}
 */
export async function getExhibitionList(path = apiPath) {
  const url = path + "api/exhibitions";
  try {
    const response = await dataService.axiosGet(url);
    return response?.data?.exhibitions;
  } catch (e) {
    console.error(e);
  }
  return undefined;
}

export async function getRelatedResourcesLinks(
  _id,
  links = [],
  excludeExternalHosts = [],
  idManagerBaseUrl
) {
  let toReturn = JSON.parse(JSON.stringify(links));
  toReturn.forEach((link) => {
    link.target = "_blank";
  });

  let seenUrls = links.map((link) => link.url);

  const id = idManagerBaseUrl + getIndexedId(_id);

  let items = [];
  try {
    // get the related content

    let typeMap = await getLinksFromIdManager([
      {
        motivation: internal.ID_MANAGER_RELATED_CONTENT_MOTIVATION,
        body_generator: internal.ID_MANAGER_TARGET_GENERATOR,
        body_id: id
      },
      {
        motivation: internal.ID_MANAGER_RELATED_CONTENT_MOTIVATION,
        body_generator: internal.ID_MANAGER_RELATED_COLLECTION_LOD_GENERATOR,
        body_id: id
      }
    ]);

    for (let set of Object.values(typeMap)) {
      items = items.concat(set);
    }

    // @todo temporary fix for null appearing id manager response target
    items = items.filter((result) => !result.id.includes("null"));
  } catch (e) {
    console.error(e);
  }
  if (items.length == 0) {
    return toReturn;
  }

  // need to filter out the LOD references...
  items.forEach((idLink) => {
    if (
      idLink.id.includes("data.getty.edu") ||
      idLink.id.includes("staging-data.aws.getty.edu")
    ) {
      return;
    }
    let link = {
      text: idLink.title,
      url: idLink.id
    };
    if (
      excludeExternalHosts.some((exclude) =>
        link.url.toLowerCase().includes(exclude.toLowerCase())
      )
    ) {
      return;
    }

    if (seenUrls.includes(link.url) == false) {
      seenUrls.push(link.url);
      toReturn.push({
        url: link.url,
        text: link.text,
        // this may not be necessary, but it does keep the link arrow direction consistent
        iconName: "outbound",
        target: "_blank"
      });
    }
  });

  toReturn.sort((a, b) => (a.text < b.text ? -1 : 1));
  return toReturn;
}
